import { VerificationService } from 'common/data';
import { action } from 'mobx';

class VerificationStore {
	constructor(rootStore) {
		this.service = new VerificationService(rootStore.app.baasic.apiClient);
	}

	@action.bound
	sendVerificationCode = async sendVerificationCodeParams => {
		const response = await this.service.sendVerificationCode(sendVerificationCodeParams);
		return response.data;
	};

	@action.bound
	validateVerificationCode = async validateVerificationCodeParams => {
		const response = await this.service.validateVerificationCode(validateVerificationCodeParams);
		return response.data;
	};
}

export default VerificationStore;



// WEBPACK FOOTER //
// ./src/modules/membership/stores/VerificationStore.js